import { useState, useEffect, useCallback } from 'react';
import type { Rating } from '@segmently/schema-models/entities';
import { RatingService } from '@modules/firebase-core/services/RatingService';

export function useRatings(projectId: string) {
  const [ratings, setRatings] = useState<Rating[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!projectId) return;
    setLoading(true);
    setError('');

    const service = new RatingService(projectId);
    const unsub = service.subscribe(
      (data) => { setRatings(data); setLoading(false); },
      (err) => { console.error('Error listening ratings:', err); setError('Failed to load ratings.'); setLoading(false); },
    );
    return () => unsub();
  }, [projectId]);

  const createRating = useCallback(async (data: Partial<Rating>) => {
    const service = new RatingService(projectId);
    return service.create(data);
  }, [projectId]);

  const updateRating = useCallback(async (id: string, data: Partial<Rating>) => {
    const service = new RatingService(projectId);
    return service.update(id, data);
  }, [projectId]);

  const deleteRating = useCallback(async (id: string) => {
    const service = new RatingService(projectId);
    return service.delete(id);
  }, [projectId]);

  return { ratings, loading, error, setError, createRating, updateRating, deleteRating };
}
